"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxContent = exports.BoxHeader = exports.BoxContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ BOX > STYLE ] ########################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var paintVisibility = function paintVisibility() {
  return "\n\n  border-bottom: solid 1px var(--color-light);\n\n  svg {\n    transform: rotate(45deg);\n    path {\n      fill: var(--color-darker)!important;\n    }\n  }\n\n";
};

var hoverEffects = function hoverEffects(noHover) {
  if (!noHover) {
    return null;
  }

  ;
  return "\n    &:hover {\n      cursor: pointer;\n      box-shadow: var(--shadow);\n\n      h4 {\n        color: var(--color-accent)!important;\n      }\n      svg {\n        path {\n          fill: var(--color-accent)!important;\n        }\n      }\n    }\n  ";
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var BoxContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__BoxContainer",
  componentId: "su8wjs-0"
})(["margin-bottom:var(--gutter-small);"]); // 3.1. END ....................................................................
// 3.1. MAIN CONTAINER .........................................................


exports.BoxContainer = BoxContainer;

var BoxHeader = _styledComponents["default"].button.withConfig({
  displayName: "indexstyle__BoxHeader",
  componentId: "su8wjs-1"
})(["display:flex;justify-content:space-between;align-items:flex-start;width:100%;background:transparent;border:none;text-align:left;padding:var(--gutter-small);border:solid 1px var(--color);border-radius:var(--radius-small);transition:var(--transition-fast);outline:none;", " div{width:100%}svg{transition:var(--transition-fast);transform:rotate(0deg);path{transition:var(--transition-fast);}}h4{font-weight:var(--weight-bold);margin:0 0 var(--gutter-small) 0;transition:var(--transition-fast);", "}small{color:var(--color-dark);}ul{", " li{display:flex;color:var(--color-dark);", " &:not(:last-child){padding-right:var(--gutter-small);border-right:solid 1px var(--color-light);}&:marker{display:none;}img{display:block;max-width:none;width:var(--gutter);height:var(--gutter);}div,small{strong{", ";}}}}", ""], function (_ref) {
  var noHover = _ref.noHover;
  return noHover ? hoverEffects(true) : hoverEffects(false);
}, (0, _architectMixins._mixin_font_size)('medium'), (0, _architectMixins._mixin_make_list)('row'), (0, _architectMixins._mixin_font_size)('small'), (0, _architectMixins._mixin_font_size)('small'), function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible && paintVisibility();
}); // 3.1. END ....................................................................
// 3.1. MAIN CONTAINER .........................................................


exports.BoxHeader = BoxHeader;

var BoxContent = _styledComponents["default"].aside.withConfig({
  displayName: "indexstyle__BoxContent",
  componentId: "su8wjs-2"
})(["padding:var(--gutter-small);margin:var(--gutter-small) var(--gutter-small) 0 var(--gutter-small);border-radius:var(--radius-small);background:var(--color-white);", " &:after{top:-10px!important;}nav{ul{", " justify-content:flex-end;padding-bottom:var(--gutter-small);margin-bottom:var(--gutter-small);border-bottom:solid 1px var(--color-light);}}"], (0, _architectMixins._mixin_arrow)('top', 'var(--color-white)'), (0, _architectMixins._mixin_make_list)('row')); // 3.1. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.BoxContent = BoxContent;